import colors from "assets/theme/base/colors";

const { black } = colors;

const buttonBase = {
  defaultProps: {
    disableRipple: true,
  },
  styleOverrides: {
    // Override styles for the root
    root: {
      color: black.main,

      // Increase specificity for targeted classes
      "&.MuiMultiSectionDigitalClockSection": {
        color: `${black.main} !important`,
      },
    },
  },
};

export default buttonBase;
